import { View } from 'foundations-components/components/View';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const getSentimentTagUse = sentiment => {
  switch (sentiment) {
    case 'POSITIVE':
      return 'success';
    case 'NEGATIVE':
      return 'danger';
    case 'WARNING':
      return 'warning';
    default:
      return 'default';
  }
};
const BadgeBlock = ({
  block
}) => {
  return /*#__PURE__*/_jsx(View, {
    alignSelf: "center",
    display: "inline-block",
    children: /*#__PURE__*/_jsx(Tag, {
      inline: true,
      use: getSentimentTagUse(block.sentiment),
      children: /*#__PURE__*/_jsx(TruncateString, {
        maxWidth: 200,
        children: block.label
      })
    })
  });
};
export default BadgeBlock;